export function highlightText(text, searchText, classes) {
  if (searchText) {
    const parts = text.toLowerCase().split(searchText.toLowerCase())
    return parts.map((part, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <span key={index}>
        {index > 0 ? <span className={classes.bolderText}>{searchText}</span> : null}
        {part}
      </span>
    ))
  }
  return text
}

export function highlightTextV2(text, searchText) {
  if (searchText) {
    const regex = new RegExp(`(${searchText})`, 'gi')
    return text.replace(regex, `<span class="highline-text">$1</span>`)
  }
  return text
}
